export const HttpErrorCodes: { [key: string]: number } = {
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  INTERNAL_ERROR: 500,
  AUTH_LIMIT_EXCEEDED: 429,
};
